import { mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _mergeProps(_ctx.themeDataAttr, {
    ref: "editor",
    class: ["viewer__image-editor top-left fill-block", { loading: !_ctx.imageEditor }]
  }), null, 16))
}